import React, { useState, useEffect } from 'react';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';
import { brandService } from '../../services/brandService';
import { connectorService } from '../../services/connectorService';

export default function JobFilters({ filters, onFiltersChange, loading }) {
  const [brands, setBrands] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  // Load filter options using existing services
  useEffect(() => {
    const loadFilterOptions = async () => {
      try {
        setLoadingData(true);
        
        // Load brands and platforms using existing services
        const [brandsData, platformsData] = await Promise.all([
          brandService.getBrands(),
          connectorService.getPlatforms()
        ]);
        
        setBrands(brandsData || []);
        setPlatforms(platformsData.platforms || platformsData || []);
      } catch (error) {
        console.error('Error loading filter options:', error);
        // Fallback to empty arrays if API fails
        setBrands([]);
        setPlatforms([]);
      } finally {
        setLoadingData(false);
      }
    };

    loadFilterOptions();
  }, []);

  const handleFilterChange = (field, value) => {
    onFiltersChange({ [field]: value });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Filters
        </Typography>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <FormControl fullWidth size="small">
          <InputLabel>Brand</InputLabel>
          <Select
            value={filters.brand_id}
            label="Brand"
            onChange={(e) => handleFilterChange('brand_id', e.target.value)}
            disabled={loading}
          >
            <MenuItem value="">All Brands</MenuItem>
            {brands.map(brand => (
              <MenuItem key={brand.id} value={brand.id}>
                {brand.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <FormControl fullWidth size="small">
          <InputLabel>Platform</InputLabel>
          <Select
            value={filters.platform_id}
            label="Platform"
            onChange={(e) => handleFilterChange('platform_id', e.target.value)}
            disabled={loading}
          >
            <MenuItem value="">All Platforms</MenuItem>
            {platforms.map(platform => (
              <MenuItem key={platform.id} value={platform.id}>
                {platform.display_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <FormControl fullWidth size="small">
          <InputLabel>Schedule Status</InputLabel>
          <Select
            value={filters.status}
            label="Schedule Status"
            onChange={(e) => handleFilterChange('status', e.target.value)}
            disabled={loading}
          >
            <MenuItem value="all">All Schedules</MenuItem>
            <MenuItem value="enabled">Active Only</MenuItem>
            <MenuItem value="disabled">Paused Only</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      
      <Grid item xs={12} sm={6} md={2.4}>
        <FormControl fullWidth size="small">
          <InputLabel>Job Status</InputLabel>
          <Select
            value={filters.job_status}
            label="Job Status"
            onChange={(e) => handleFilterChange('job_status', e.target.value)}
            disabled={loading}
          >
            <MenuItem value="all">All Jobs</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
            <MenuItem value="running">Running</MenuItem>
            <MenuItem value="cancelled">Cancelled</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
